import qs from "qs";
import { FilterDef, HTTPGenericResponse } from "../../constants/FinanceModels";
import { getFilterValue } from "../../utils/FilterUtils";
import { useApi } from "../Api";
import {
    ID_FILTER_LEGAL_ENTITIES,
    ID_FILTER_DEALERS,
    ID_FILTER_MSTYPE,
    ID_FILTER_NAME,
    ID_FILTER_SEARCH,
    ID_FILTER_STATUS,
    ID_FILTER_VALID_FROM,
    ID_FILTER_VALID_TO,
    ID_FILTER_CLUSTERS_TYPE
} from "../../pages/cluster/constants/ClustersFilters";
import dayjs from "dayjs";
import { useContext } from "react";
import { GlobalContext } from "../../../../util/state/GlobalContextProvider";

export const useClustersRepository = () => {
    const { GET, POST, PUT } = useApi();

    const PATH = "/finance/cluster";
    const {  globalData: { user } } = useContext(GlobalContext);
    const allLegalEntities: any[] = user.legalEntities?.filter((x: any) => x.name.toLowerCase() !== "all").map((x: any) => x.name);


    function getClusters(offset: number, limit: number, sort: string | null, order: string | null, filterDefs: FilterDef[] = []): Promise<HTTPGenericResponse> {
        let search = getFilterValue(ID_FILTER_SEARCH, filterDefs);
        let name = getFilterValue(ID_FILTER_NAME, filterDefs);
        let msType = getFilterValue(ID_FILTER_MSTYPE, filterDefs);
        let types = getFilterValue(ID_FILTER_CLUSTERS_TYPE, filterDefs);
        let validFrom: Date = getFilterValue(ID_FILTER_VALID_FROM, filterDefs);
        let validTo: Date = getFilterValue(ID_FILTER_VALID_TO, filterDefs);
        let status = getFilterValue(ID_FILTER_STATUS, filterDefs);
        let legalEntities = getFilterValue(ID_FILTER_LEGAL_ENTITIES, filterDefs) || allLegalEntities;
        let dealers = getFilterValue(ID_FILTER_DEALERS, filterDefs);
        

        let params = {
            offset: offset,
            limit: limit,
            sort: sort,
            order: order,
            search: search,
            msTypology: msType,
            types: types,
            name: name,
            validFrom: validFrom ? dayjs(validFrom).toISOString() : null,
            validTo: validTo ? dayjs(validTo).toISOString() : null,
            validStatus: status,
            legalEntities,
            dealers
        }

        return GET(`${PATH}/all`, { params: params, paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }) });
    }

    function getClusterNames(search: string): Promise<any> {
        let params = {
            search: search,
            limit: 10
        }
        return GET(`${PATH}/names`, { params });
    }


    function findAllClusters(): Promise<HTTPGenericResponse> {
        let legalEntities = allLegalEntities;
        let params = {
            legalEntities
        }
        return GET(`${PATH}/all`, {params: params, paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }) });
    }

    function getSummary(filterDefs: FilterDef[] = []): Promise<HTTPGenericResponse> {
        let search = getFilterValue(ID_FILTER_SEARCH, filterDefs);
        let name = getFilterValue(ID_FILTER_NAME, filterDefs);
        let msType = getFilterValue(ID_FILTER_MSTYPE, filterDefs);
        let types = getFilterValue(ID_FILTER_CLUSTERS_TYPE, filterDefs);
        let validFrom: Date = getFilterValue(ID_FILTER_VALID_FROM, filterDefs);
        let validTo: Date = getFilterValue(ID_FILTER_VALID_TO, filterDefs);
        let status = getFilterValue(ID_FILTER_STATUS, filterDefs);
        let legalEntities = getFilterValue(ID_FILTER_LEGAL_ENTITIES, filterDefs) || allLegalEntities;
        let dealers = getFilterValue(ID_FILTER_DEALERS, filterDefs);

        let params = {
            search: search,
            msTypology: msType,
            types: types,
            name: name,
            validFrom: validFrom ? dayjs(validFrom).toISOString() : null,
            validTo: validTo ? dayjs(validTo).toISOString() : null,
            validStatus: status,
            legalEntities,
            dealers
        }

        return GET(`${PATH}/all-status-summary`, { params: params, paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }) });
    }

    function createCluster(cluster: any): Promise<HTTPGenericResponse> {
        return POST(`${PATH}`, cluster, {}, true)
    }

    function updateCluster(id: number, status: string, msTypology: string, type: string, name: string, validFrom : Date, validTo : Date ): Promise<HTTPGenericResponse> {
        let cluster: any = {
            validStatus: status,
            name: name,
            msTypology: msTypology,
            type: type,
            validFrom: validFrom ? dayjs(validFrom).toISOString() : null,
            validTo: validTo ? dayjs(validTo).toISOString() : null,
        }
        return PUT(`${PATH}/${id}`, cluster, {}, true);
    }

    function duplicateCluster(id: string, cluster: any): Promise<HTTPGenericResponse> {
        return POST(`${PATH}/${id}`, cluster, {}, true);
    }


    return { getClusters, getClusterNames, getSummary, createCluster, updateCluster, duplicateCluster, findAllClusters };
}